import { CustomHttpClient } from '../../providers/CustomHttpClient';
import { Injectable } from '@angular/core';
import { Beneficiary, Cupom, CupomBackend } from '../../model/cupom';
import { map } from 'rxjs/operators';
import { UserDetails } from '../../model/userDetails'

@Injectable({
  providedIn: 'root'
})
export class CupomService {

  public cupons: Cupom[] = [];

  constructor(private http: CustomHttpClient) { }

  onSearchProtocolo(consulta: string, tipoConsulta: number, programa: number, user: UserDetails) {
    let apiUrl = '';
    if (tipoConsulta === 1) {
      apiUrl = `api/cupom/GetProtocolo/${consulta}/${programa}`;
    } else if (tipoConsulta === 2) {
      apiUrl = `api/cupom/GetCPF/${consulta}/${programa}/${user.utiliza_Cadastro_Dinamico}/${user.param_is_pln}`;
    }
    return this.http.Get(apiUrl);
  }

  onCreateCupom(cupom: CupomBackend) {
    return new Promise((resolve, reject) => {
      this.http.Post("api/cupom", cupom).subscribe((res) => {
        resolve(res);
      }, (err) => {
        reject(err.json());
      });
    });
  }

  onCancela(value: string, isRus: number, is_Ressarcimento: number) {
    return new Promise((resolve, reject) => {
      this.http.Post("api/cupom/PostCancelar/" + value + "/" + is_Ressarcimento + "/" + isRus, null).subscribe((res) => {
        resolve(res);
      }, (err) => {
        reject(err.json());
      });
    });
  }

  onReativa(value: string, isRessarcimento: number, isRus: number) {
    return new Promise((resolve, reject) => {
      this.http.Post("api/cupom/PostReativar/" + isRessarcimento + "/" + isRus + "/" + value, null).subscribe((res) => {
        resolve(res);
      }, (err) => {
        reject(err.json());
      });
    });
  }

  onEditContact(protocolo: string, isRessarcimento: number, email: string, isRus: number, nr_cel: string) {
    return new Promise((resolve, reject) => {
      this.http.Post(`api/cupom/UpdateContactCupom/${protocolo}/${isRessarcimento}/${email}/${isRus}/${nr_cel}`, null).subscribe((res) => {
        resolve(res);
      }, (err) => {
        reject(err.json());
      });
    });
  }

  onReenvioEmail(protocolo: string, isRessarcimento: number, is_pln: number) {
    return new Promise((resolve, reject) => {
      this.http.Post(`api/cupom/ReenviaEmailCupom/${protocolo}/${isRessarcimento}/${is_pln}`, null).subscribe((res) => {
        resolve(res);
      }, (err) => {
        reject(err.json());
      });
    });
  }

  onSearchLogs(isRessarcimento: number, isProtocolo: number) {
    return this.http.Get("api/cupom/GetLogs/" + isRessarcimento + "/" + isProtocolo);
  }

  onRegisterInduction(beneficiary: Beneficiary, is_pln: string) {
    return new Promise((resolve, reject) => {
      this.http.Post("api/cupom/RegisterInduction/" + is_pln, beneficiary).subscribe((res) => {
        resolve(res);
      }, (err) => {
        reject(err.json());
      });
    });
  }
}
